import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { Environment, ENVIRONMENT } from '@web/config';
import { RouteFragment } from '@web/common';

@Component({
  selector: 'app-privacy-policy-clause',
  imports: [],
  templateUrl: './privacy-policy-clause.component.html',
  styleUrl: './privacy-policy-clause.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivacyPolicyClauseComponent {
  private readonly environment = inject<Environment>(ENVIRONMENT);

  protected readonly link = this.prepareLink();

  private prepareLink(): string {
    return `${this.environment.AppUrl.Shop}/${RouteFragment.PL_PrivacyPolicy}`;
  }
}
